export default __webpack_public_path__ + "static/gangli-5cccbd28f9ef95827d8f3e44ec6fd3c8.png";